<template>
  <div>
    <!-- sign in -->
    <div v-if="active == true">
      <br />
      <h2 class="ml-2 mt-2 hedderLogin" id="getting-started">
        <a href="#getting-started" class="header-anchor">Sign </a> In
      </h2>
      <br />
      <form class="container mt-1 ml-2" style="width: 100%">
        <p>
          <label class="fontSizeData">Username</label>
          <input class="inputForm" v-model="username" type="text" />
        </p>
        <p>
          <label class="fontSizeData">Password</label>
          <input
            v-model="password"
            class="inputForm"
            @keydown.enter="login"
            type="password"
          />
        </p>
      </form>
      <vs-row class="mt-1 ml-2 container" vs-w="12">
        <vs-checkbox
          class="fontSizeData"
          color="success"
          v-model="rememberme"
          @change="getFingerprint"
          >Remember me</vs-checkbox
        ><vs-spacer />
        <a
          id="buttonfg"
          class="fontSizeData"
          @click="active = 'forgotpassword'"
          rel="noopener noreferrer"
          >Forgot Password?</a
        >
      </vs-row>
      <br />
      <br />
    </div>
    <!-- forgot password -->
    <div v-if="active == 'forgotpassword'">
      <forgotpassword />
    </div>
    <!-- sign up -->
    <div v-if="active == false" class="mt-4">
      <signup />
    </div>

    <vs-row v-if="active == true">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-button
          color="success"
          class="container-fluid"
          type="border"
          @click="login()"
          style="width: 65%; border-radius: 20px"
          ><h5>Sign In</h5>
        </vs-button>
      </vs-col>
    </vs-row>
    <br />
    <vs-row v-if="active == true">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <h6 class="fontSizeData">OR</h6>
      </vs-col>
    </vs-row>
    <br />
    <vs-row v-if="active == true">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-button
          color="success"
          class="container-fluid"
          type="filled"
          @click="active = !active"
          style="width: 65%; border-radius: 20px"
          ><h5>Sign Up</h5>
        </vs-button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import forgotpassword from "./forgotpassword.vue";
import signup from "./signup.vue";

import FingerprintJS from "@fingerprintjs/fingerprintjs";

export default {
  components: {
    forgotpassword,
    signup,
  },
  data() {
    return {
      username: "",
      active: true,
      rememberme: false,
      password: "",
      visitorId: null,
      users_Fraser: [
        {
          id: 1,
          path: "/customdashboard",
          user: "Kendell",
        },
        {
          id: 2,
          path: "/customdashboardRojana",
          user: "Endeavor",
        },
        {
          id: 3,
          path: "/customdashboardBangplee",
          user: "Unicorn",
        },
        {
          id: 4,
          path: "/customdashboardJasperW3",
          user: "JasperW3",
        },
        {
          id: 5,
          path: "/customdashboardJasperW1",
          user: "JasperW1",
        },
      ],
    };
  },
  methods: {
    push(accessToken, refreshToken, token, username, pack, perm, mode, admin) {
      this.$session.set("accessToken", accessToken);
      this.$session.set("refreshToken", refreshToken);
      this.$session.set("token", token);
      this.$session.set("username", username);
      this.$session.set("package", pack);
      this.$session.set("controlperm", perm);
      this.$session.set("role", mode);
      if (admin) this.$session.set("admin", admin);
      this.$API
        .post("checkin", {
          username: this.$session.get("username"),
        })
        .catch((err) => {
          console.log(err);
        });
      this.activeLoading = true;
      this.$vs.loading({
        type: "default",
      });
      setTimeout(() => {
        this.activeLoading = false;
        this.$vs.loading.close();
        var fullpath = this.$session.get("path");
        if (fullpath) this.$router.push({ path: fullpath.fullPath });
        else if (
          username == "pttdemo" ||
          username == "camilliandemo" ||
          username == "spartan"
        )
          this.$router.push({ path: "/IndoorOverview" });
        else if (username == "betagrodemo" || admin == "betagrodemo")
          this.$router.push({ path: "/IndoorDashboard" });
        else if (username == "warehousedemo")
          this.$router.push({ path: "/warehouse" });
        else if (username == "Rivacold01" || admin == "Rivacold01")
          this.$router.push({ path: "/IndoorOverview" });
        else if (
          username === "dhanarak-admin" ||
          username === "dhanarak-user" ||
          admin == "dnet"
        )
          this.$router.push({ path: "/IndoorOverview" });
        else if (
          username == "syntecdemo" ||
          username == "SCGdemo" ||
          username == "TAdemo" ||
          username == "Ramademo"
        )
          this.$router.push({ path: "/IndoorOverview" });
        else if (username == "unicorndemo")
          this.$router.push({ path: "/IndoorOverview" });
        else if (username == "frasers.kho" || username == "Galaxy")
          this.$router.push({ path: "/mapOverview" });
        else if (username == "birchteladmin" || admin == "birchteladmin")
          this.$router.push({ path: "/dashboard/sriboonrueng" });
        else if (username == "yamahademo")
          this.$router.push({ path: "/yamaha/overview" });
        else if (username == "MHESIdemo")
          this.$router.push({ path: "/mhesi/dashboard" });
        else if (username == "stockdemo")
          this.$router.push({ path: "/Stock/Dashboard/WarehouseLocation" });
        else if (username == "GPSdemo")
          this.$router.push({ path: "/map-tracking" });
        else if (username == "LTCdemo")
          this.$router.push({ path: "/LTC/dashboard/floor%201" });
        else if (username == "awcdemo")
          this.$router.push({ path: "/asset-world/dashboard" });
        else if (admin == "poonsak.ngk") 
          this.callsensor();
        else if (
          ["Kendell", "Endeavor", "Unicorn", "JasperW1", "JasperW3"].includes(
            username
          )
        )
          this.users_Fraser.forEach((element) => {
            // console.log(element);
            if (username == element.user) {
              this.$router.push({ path: element.path });
            }
          });
        else this.$router.push({ path: "/overview" });
      }, 1000);
    },
    async getFingerprint() {
      if (this.rememberme) {
        await FingerprintJS.load().then((fp) => {
          // The FingerprintJS agent is ready.
          // Get a visitor identifier when you'd like to.
          fp.get().then((result) => {
            // This is the visitor identifier:
            this.visitorId = result.visitorId;
            // console.log(visitorId);
          });
        });
      }
    },
    async login() {
      console.log(this.visitorId);
      await this.$http
        .post(this.$url2 + "authen", {
          headers: {
            "Access-Control-Request-Method": "*",
            "Access-Control-Request-Headers": "*",
            Origin: "*",
          },
          username: this.username,
          password: this.password,
          fingerprint: this.visitorId,
        })
        .then((result) => {
          if (result.status == 200) {
            let data = result.data;
            // let data = JSON.parse(result.data)        //JSON.stringfy()
            // console.log(data.user.admin)
            if (data.user.admin) {
              // console.log(data.user.admin)
              // this.$API.get('getAdmintoken/'+data.user.admin)
              // .then((adminToken)=>{
              //   this.$API.post('checkin',{
              //     username: this.$session.get('username')
              //   }).catch((err)=>{
              //     console.log(err)
              //   })
              //   console.log(adminToken)})
              let user = data.user;
              this.push(
                data.accessToken,
                data.refreshToken,
                user.token,
                user.username,
                user.package,
                user.controlperm,
                "user",
                user.admin
              );
            } else {
              console.log("case 2");
              let user = data.user;
              this.push(
                data.accessToken,
                data.refreshToken,
                user.token,
                user.username,
                user.package,
                null,
                "admin",
                user.username
              );
            }
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status == 401) {
            this.$vs.notify({
              title: "Login was unsuccessful",
              text: "The username or password provided is incorrect.",
              color: "danger",
              position: "top-center",
              icon: "clear",
            });
          } else if (err.response.status == 403) {
            this.$vs.notify({
              title: "Login was unsuccessful",
              text: "Please wait for session expire or This user is already login",
              color: "danger",
              position: "top-center",
              icon: "clear",
            });
          } else {
            this.$vs.notify({
              title: "Login was unsuccessful",
              text: "Something happen with the server",
              color: "danger",
              position: "top-center",
              icon: "clear",
            });
          }
        });
    },
    async callsensor() {
      await this.$API.get("sensors/user").then((result) => {
        this.link2(result.data[0]);
        // // console.log(this.sensorlist)
      });
    },
    link2(item) {
      this.$session.set("nwname", item.network);
      this.$session.set("statussensor", item.active);
      this.$session.set("nwid", item.nwid);
      this.$session.set("sensorname", item.name);
      this.$session.set("sensorid", item.serial_id);
      this.$session.set("gatewayid", item.gatewayid);
      this.$session.set("type", item.type);
      this.$session.set("lora", item.lora);
      this.$session.set("location", item.location);
      // this.$session.set("idsensor", this.findID(item));
      this.$router.push({ path: "/sensordashboard" });
    },
  },
};
</script>

<style>
</style>